import { LogoLockup } from "./Logo";

const nav = [
  { label: "About", id: "about" },
  { label: "Capabilities", id: "services" },
  { label: "Strengths", id: "strengths" },
  { label: "Leadership", id: "leadership" },
  { label: "Contact", id: "contact" },
];

export default function Footer() {
  const go = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer
      className="border-t border-vg-border bg-white py-14"
      data-testid="site-footer"
    >
      <div className="mx-auto flex max-w-[1400px] flex-col gap-10 px-6 lg:flex-row lg:items-center lg:justify-between lg:px-10">
        <div>
          <LogoLockup />
          <p className="mt-4 max-w-sm text-sm text-vg-muted">
            Engineering, Procurement &amp; Construction — power transmission,
            renewables and infrastructure across India.
          </p>
        </div>

        <nav className="flex flex-wrap gap-x-8 gap-y-3">
          {nav.map((n) => (
            <button
              key={n.id}
              onClick={() => go(n.id)}
              data-testid={`footer-link-${n.id}`}
              className="text-sm font-medium text-vg-ink/70 transition-colors duration-300 hover:text-vg-primary"
            >
              {n.label}
            </button>
          ))}
        </nav>
      </div>

      <div className="mx-auto mt-10 flex max-w-[1400px] flex-col gap-2 border-t border-vg-border px-6 pt-6 text-xs text-vg-muted lg:flex-row lg:items-center lg:justify-between lg:px-10">
        <span>
          © {new Date().getFullYear()} Venus Green Renewables &amp; Energy Pvt.
          Ltd. All rights reserved.
        </span>
        <span>Surat, Gujarat · India</span>
      </div>
    </footer>
  );
}
